import SwitchDispositionFields from "./SwitchDispositionFields";
import DmrDispositionFields from "./DmrDispositionFields";
import { DISPOSITION_FIELD_COMPONENTS } from "views/Raw/FaxDisposition/FaxDispositionConfig";

export const DISPOSITION_FIELD_COMPONENT_MAP = {
  [DISPOSITION_FIELD_COMPONENTS.SWITCH]: SwitchDispositionFields,
  [DISPOSITION_FIELD_COMPONENTS.DMR]: DmrDispositionFields,
};

export const getDispositionFieldComponent = (componentKey) =>
  DISPOSITION_FIELD_COMPONENT_MAP[componentKey] || SwitchDispositionFields;
